import React, { useState, useEffect } from 'react';
import { useScrollPosition } from '@contexts/ScrollContext';
import './ScrollToTop.scss';

interface ScrollButtonProps {
  btnText: string;
}

export const ScrollButton = ({ btnText }: ScrollButtonProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const { scrollTop } = useScrollPosition();

  useEffect(() => {
    setIsVisible(scrollTop > 300);
  }, [scrollTop]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    setIsVisible(false);
  };

  return isVisible ? (
    <div className='scroll-to-top'>
      <button className='scroll-to-top__button icon-chevron-up' onClick={scrollToTop}></button>
      <p className='scroll-to-top__text'>{btnText}</p>
    </div>
  ) : null;
};
